import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=92b9c766&lang=pug&"
import script from "./v-button.vue?vue&type=script&lang=js&"
export * from "./v-button.vue?vue&type=script&lang=js&"
import style0 from "./v-button.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports